import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { HtmlPipe } from '../../html.pipe';

export type BlogCardViewModel = {
    cardImage: { alt: string; src: string };
    url: string;
    title: string;
    author: string;
    description: string;
    showMoreBtn: boolean;
};

@Component({
    selector: 'blog-card',
    templateUrl: './blog-card.component.html',
    styleUrls: ['./blog-card.component.scss'],
    imports: [NgOptimizedImage, HtmlPipe, RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    host: {
        '[class]': "'card ' + direction()",
    },
})
export class BlogCardComponent {
    item = input.required<BlogCardViewModel, any>({
        transform: (v) => {
            const vm = { ...v } as BlogCardViewModel;
            vm.author = (v.authors ?? []).map((a) => a.name).join(', ');
            vm['showMoreBtn'] = v.showMoreBtn === true;
            vm['cardImage'] = { alt: v.title, src: `${environment.base_url}/${v.cardImage?.[0]?.['path']}` };
            return vm;
        },
    });
    direction = input<'hor' | 'ver'>('ver');
}
